import type { StoreSearchResult } from '~/services/api/search/types'

export type SelectionId = string | number

export interface StoreCardView extends Pick<StoreSearchResult, 'average_rating' | 'review_count'> {
  address: string
  city: string
  cover: string
  dine_in_available: boolean
  distance_miles?: number
  id: number
  is_favorite: boolean
  name: string
  slug: string
  state: string
}

export const getRecord = (value: unknown): Record<string, unknown> | null => {
  if (typeof value !== 'object' || value === null || Array.isArray(value)) return null
  return Object.entries(value).reduce<Record<string, unknown>>((record, [key, entry]) => {
    record[key] = entry
    return record
  }, {})
}

export const mapStore = (store: StoreSearchResult): StoreCardView => ({
  address: store.address ?? '',
  average_rating: store.average_rating,
  city: store.city ?? '',
  cover: store.cover ?? '',
  dine_in_available: store.dine_in_available,
  ...(store.distance_miles === null || store.distance_miles === undefined
    ? {}
    : { distance_miles: store.distance_miles }),
  id: store.id,
  is_favorite: store.is_favorite,
  name: store.name,
  review_count: store.review_count,
  slug: store.slug,
  state: store.state ?? ''
})
